import { Page } from '@/core/architecture'

import { PaymentCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * PaymentCreate Page
 * Implemented as a practical sample.
 */
export const PaymentCreate: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <PaymentCreateTemplate
      state={state}
      onSubmitCreatePayment={actions.onSubmitCreatePayment}
    />
  )
}
